import { render, staticRenderFns } from "./WorkerInfo.vue?vue&type=template&id=16061273&scoped=true"
import script from "./WorkerInfo.vue?vue&type=script&lang=js"
export * from "./WorkerInfo.vue?vue&type=script&lang=js"
import style0 from "./WorkerInfo.vue?vue&type=style&index=0&id=16061273&prod&scoped=true&lang=scss"
import style1 from "./WorkerInfo.vue?vue&type=style&index=1&id=16061273&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16061273",
  null
  
)

export default component.exports